import {
  ADICIONAR_FORMAS_PAGAMENTO,
  ALTERAR_SITUACAO_PAGAMENTO
} from '../../actions/types'

const initialState = null;


export default function reducerFormaPagamento (state = initialState, action) {
  switch (action.type) {
    case ADICIONAR_FORMAS_PAGAMENTO: {
      return action.payload
    }
    case ALTERAR_SITUACAO_PAGAMENTO: {
      const formaPagamento = action.payload
      const indice = state.indexOf(formaPagamento);      
      const novaForma = Object.assign({}, formaPagamento, { situacao: 'PROCESSANDO' });
      const newState = [...state];
      newState[indice] = novaForma;
      return newState;

    }
    default: {
      return state
    }
  }
}
